import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
const { ADMIN_BG_COLOR, ADMIN_TEXT_COLOR } = constants;

let styles = {
  base: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: ADMIN_BG_COLOR,
    color: ADMIN_TEXT_COLOR,
    padding: '20px 30px',
    boxSizing: 'border-box',
    overflow: 'auto'
  },
  content: {
    height: '100%',
    paddingTop: 50
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/admin/Admin.styles.js